import { render, staticRenderFns } from "./IbxItemCardHeader.vue?vue&type=template&id=b291163c"
import script from "./IbxItemCardHeader.vue?vue&type=script&lang=js"
export * from "./IbxItemCardHeader.vue?vue&type=script&lang=js"
import style0 from "./IbxItemCardHeader.vue?vue&type=style&index=0&id=b291163c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports